export default __webpack_public_path__ + "static/media/logoImpresora.53294ee5.png";